import React, {useState} from 'react'
import "./BillingSummary.css"
import handIcon from "../../../../assets/images/flights/fluent_money-hand-16-regular.svg"

const BillingSummary = ({ refundability, onNext, isLoading, currentStep }) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleNextClick = () => {
        if (!isChecked) {
            return;
        }
        
        if (onNext) {
            onNext();
        }
    };

    return (
        <div className='billing-summary-container'>
            <div className='billing-summary-header'>
                <div>Billing Summary</div>
                {refundability && (
                    <div className='flight-popup-category'>
                        <img src={handIcon} alt="Refundable" />
                        <div>Refundable</div>
                    </div>
                )}
            </div>
            
            <div className='billing-summary-body'>
                <div className='billing-summary-tax'>
                    <div className='billing-summary-tax-label'>Base Fare</div>
                    <div className='billing-summary-tax-num'>+2000 SAR</div>
                </div>
                <div className='billing-summary-tax'>
                    <div className='billing-summary-tax-label'>Bundle (Flex)</div>
                    <div className='billing-summary-tax-num'>+150 SAR</div>
                </div>
                <div className='billing-summary-tax'>
                    <div className='billing-summary-tax-label'>Discount</div>
                    <div className='billing-summary-tax-num'>0.00 SAR</div>
                </div>
            </div>

            <div className='billing-summary-total-price'>
                <div className='billing-summary-total-price-label'>Subtotal Total</div>
                <div className='billing-summary-total-price-num'>3850 SAR</div>
            </div>

            <div className="billing-summary-privacy">
                <label className="billing-summary-privacy-label">
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                    />
                    <div className="billing-summary-privacy-text">
                        Please check to acknowledge our{" "}
                        <span>Privacy & Terms Policy</span>
                    </div>
                </label>
            </div>

            <div 
                className={`billing-summary-btn ${isLoading ? 'loading' : ''}`}
                onClick={handleNextClick}
            >
                {isLoading ? 'Submitting...' : 'Next'}
            </div>
        </div>
    )
}

export default BillingSummary